import { faVolume, faVolumeSlash } from "@fortawesome/pro-regular-svg-icons";
import { Collapse } from "@mui/material";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import { useState, type JSX } from "react";
import { FaIcon } from "../../DataDisplay/Icon/FaIcon";
import { IconButton } from "./IconButton";

type Props = {
  muted: boolean;
  onToggle: (soundOn: boolean) => void;
  onChange: (volume: number) => void;
  volume?: number;
  compactMode?: boolean;
};

const VolumeControl = ({
  muted,
  onToggle,
  onChange,
  volume = 1,
  compactMode,
}: Props): JSX.Element => {
  const [hovered, setHovered] = useState(false);
  const handleChange = (_: unknown, v: number | number[]) => {
    if (!Array.isArray(v) && v > 0) {
      onChange(v as number);
      if (muted) {
        onToggle(true);
      }
    } else {
      onToggle(false);
    }
  };

  const handleMouseEnter = () => {
    if (!compactMode) {
      setHovered(true);
    }
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      sx={{ pr: 1 }}
    >
      {muted || volume === 0 ? (
        <IconButton aria-label="volume unmute" onClick={() => onToggle(true)}>
          <FaIcon icon={faVolumeSlash} />
        </IconButton>
      ) : (
        <IconButton aria-label="volume mute" onClick={() => onToggle(false)}>
          <FaIcon icon={faVolume} />
        </IconButton>
      )}
      <Collapse in={hovered} orientation="horizontal">
        <Slider
          aria-label="volume slider"
          max={1}
          min={0}
          onChange={handleChange}
          step={0.1}
          value={muted ? 0 : volume}
          sx={{
            display: "block",
            width: 70,
            ml: 1,
            mr: 3,
          }}
        />
      </Collapse>
    </Box>
  );
};

export default VolumeControl;
